import { RP } from "./floodconf";
const PMSERVER_URL = "https://pmtileserver-staging-myzvqet7ua-uw.a.run.app";

const flooding_1996_pt = {
  id: "flooding_1996_pt",
  type: "vector",
  format: "mvt",
  tiles: [
    `${PMSERVER_URL}/cwon_data_chunked/with_1996_TC_Tr_${RP}/{z}/{x}/{y}.mvt`,
  ],
  minzoom: 0,
  maxzoom: 14,
};

const flooding_2020_pt = {
  id: "flooding_2020_pt",
  type: "vector",
  format: "mvt",
  tiles: [`${PMSERVER_URL}/cwon_data_chunked/with_2020_${RP}/{z}/{x}/{y}.mvt`],
  minzoom: 0,
  maxzoom: 14,
};

const flooding_2020_nomang_pt = {
  id: "flooding_2020_nomang_pt",
  type: "vector",
  format: "mvt",
  tiles: [
    `${PMSERVER_URL}/cwon_data_chunked/without_2020_${RP}/{z}/{x}/{y}.mvt`,
  ],
  minzoom: 0,
  maxzoom: 14,
};

const flooding_squares = {
  id: "flooding_squares",
  type: "vector",
  format: "mvt",
  tiles: [`${PMSERVER_URL}/CWON_reindexed/beveled_squares/{z}/{x}/{y}.mvt`],
  minzoom: 0,
  maxzoom: 14,
};

const mangroves_1996 = {
  id: "mangroves_1996",
  type: "vector",
  format: "mvt",
  tiles: [`${PMSERVER_URL}/vectors/GMW_1996_v3_Areas/{z}/{x}/{y}.mvt`],
  minzoom: 0,
  maxzoom: 14,
};

const mangroves_2015 = {
  id: "mangroves_2015",
  type: "vector",
  format: "mvt",
  tiles: [`${PMSERVER_URL}/vectors/GMW_2015_v3_Areas/{z}/{x}/{y}.mvt`],
  minzoom: 0,
  maxzoom: 14,
};

const mangroves_2020 = {
  id: "mangroves_2020",
  type: "vector",
  format: "mvt",
  tiles: [`${PMSERVER_URL}/vectors/GMW_2020_v3/{z}/{x}/{y}.mvt`],
  minzoom: 0,
  maxzoom: 14,
};

const CWON_RESULTS_TESELA_ALLYEARS_RepPt = {
  id: "UCSC_CWON_studyunits_points",
  type: "vector",
  format: "mvt",
  tiles: [
    `${PMSERVER_URL}/cwon-teselas/UCSC_CWON_studyunits_points/{z}/{x}/{y}.mvt`,
  ],
  minzoom: 0,
  maxzoom: 14,
};

const CWON_RESULTS_TESELA_ALLYEARS = {
  id: "UCSC_CWON_studyunits",
  type: "vector",
  format: "mvt",
  tiles: [`${PMSERVER_URL}/cwon-teselas/UCSC_CWON_studyunits/{z}/{x}/{y}.mvt`],
  minzoom: 0,
  maxzoom: 14,
};

const CWON_RESULTS_TESELA_ALLYEARS_Hex = {
  id: "UCSC_CWON_studyunits_hexagons",
  type: "vector",
  format: "mvt",
  tiles: [
    `${PMSERVER_URL}/cwon-teselas/UCSC_CWON_studyunits_hexagons/{z}/{x}/{y}.mvt`,
  ],
  minzoom: 0,
  maxzoom: 14,
};

const CWON_countries = {
  id: "UCSC_CWON_countrybounds",
  type: "vector",
  format: "mvt",
  tiles: [
    `${PMSERVER_URL}/vectors/cwon-countries/UCSC_CWON_countrybounds/{z}/{x}/{y}.mvt`,
  ],
  minzoom: 0,
  maxzoom: 4,
};

const sources = [
  ["flooding_1996_pt", flooding_1996_pt],
  ["mangroves_2015", mangroves_2015],
  ["mangroves_1996", mangroves_1996],
  ["mangroves_2020", mangroves_2020],
  ["flooding_2020_pt", flooding_2020_pt],
  ["flooding_2020_nomang_pt", flooding_2020_nomang_pt],
  ["flooding_squares", flooding_squares],
  ["UCSC_CWON_studyunits", CWON_RESULTS_TESELA_ALLYEARS],
  ["UCSC_CWON_studyunits_points", CWON_RESULTS_TESELA_ALLYEARS_RepPt],
  ["UCSC_CWON_studyunits_hexagons", CWON_RESULTS_TESELA_ALLYEARS_Hex],
  ["UCSC_CWON_countrybounds", CWON_countries],
];

export default sources;
